import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { twitterAutomationKeys } from '../twitterAutomation.keys';
import { mapFrontendToBackend } from '../twitterAutomation.mapper';
import { updateAutomation } from '../twitterAutomation.service';
export const useUpdateAutomation = (subdomain = getSubdomain(), communityExternalAccountId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ automationId, data }) => updateAutomation(subdomain, automationId, mapFrontendToBackend(data, communityExternalAccountId)),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: twitterAutomationKeys.list(subdomain) });
            queryClient.invalidateQueries({
                queryKey: twitterAutomationKeys.item(subdomain, variables.automationId),
            });
        },
    });
};
